import { useAuth } from '@/contexts/AuthContext';
import { CampaignSelector } from '@/components/campaign';
import { useCampaignStore } from '@/stores';

/** For someone sent here from the public win number page: whose account and which campaign they are now looking at. */
export function SignedInBar() {
  const { user } = useAuth();
  const campaign = useCampaignStore((s) => s.selectedCampaign);
  if (!user || !campaign) return null;
  return (
    <div className="mx-auto mb-6 flex max-w-3xl flex-wrap items-center gap-2 rounded-lg border bg-muted/40 px-4 py-2 text-sm">
      <span>
        Signed in as <b>{user.firstName} {user.lastName}</b>, working on
      </span>
      <CampaignSelector compact />
    </div>
  );
}
